import { useCallback, useEffect, useState } from "react";

import {
	type DisplayModePreference,
	readDisplayModePreference,
	writeDisplayModePreference
} from "~/helpers/displayModePreference";
import useSaveLocalPreference from "~/hooks/useSaveLocalPreference";

const displayModeChangeEvent = "worksuite:display-mode-change";

const useDisplayModePreference = (): [DisplayModePreference, (preference: DisplayModePreference) => void] => {
	const saveLocalPreference = useSaveLocalPreference();
	const [preference, setPreference] = useState(readDisplayModePreference);

	useEffect(() => {
		const sync = () => setPreference(readDisplayModePreference());
		window.addEventListener(displayModeChangeEvent, sync);
		window.addEventListener("storage", sync);
		return () => {
			window.removeEventListener(displayModeChangeEvent, sync);
			window.removeEventListener("storage", sync);
		};
	}, []);

	const savePreference = useCallback(
		(next: DisplayModePreference) => {
			if (!saveLocalPreference(() => writeDisplayModePreference(next))) return;
			window.dispatchEvent(new Event(displayModeChangeEvent));
		},
		[saveLocalPreference]
	);

	return [preference, savePreference];
};

export default useDisplayModePreference;
